module.exports = __webpack_public_path__ + "img/male_AP_03.232527e8.png";